import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cloudinary from 'cloudinary-core';
import { Router } from '../routes';
export function assetUrl(asset) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cl = new cloudinary.Cloudinary({
    cloud_name: process.env.CLOUDINARY_CLOUD_NAME,
    secure: true
  });
  if (asset && asset.charAt(0) === '/' || asset.indexOf('http') >= 0) {
    return asset;
  }
  return cl.url(asset.split('.')[0], _objectSpread(_objectSpread({}, {
    fetchFormat: 'auto',
    quality: 'auto',
    width: 'auto',
    crop: 'scale',
    gravity: 'center'
  }), options));
}
export function getGoogleMapApiUrl(lat, _long) {
  return "https://www.google.com/maps/search/?api=1&query=".concat(lat, ",").concat(_long);
}
export function getYoutubeThumbnailUrl(videoUrl) {
  var videoId = false;
  if (/^[a-zA-Z0-9]+$/.test(videoUrl)) {
    videoId = videoUrl;
  } else {
    var matches = videoUrl.match(/https:\/\/youtu\.be\/([a-zA-Z0-9]+)/);
    if (!matches) {
      matches = videoUrl.match(/https:\/\/www.youtube.com\/watch\?v=([a-zA-Z0-9]+)/);
    }
    if (matches) {
      videoId = matches[1];
    }
  }
  return videoId ? "//img.youtube.com/vi/".concat(videoId, "/sddefault.jpg") : null;
}
export function redirect(res, route) {
  var statusCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 301;
  if (res) {
    if (res.headersSent) {
      return;
    }
    res.writeHead(statusCode, {
      Location: route
    });
    res.end();
  } else {
    Router.replaceRoute(route);
  }
}
export function routeParamSlug(fullSlug) {
  if (!fullSlug || Array.isArray(fullSlug)) {
    return fullSlug;
  }
  var slug = fullSlug.replace(/^\//, '');
  return slug.indexOf('/') !== -1 ? slug.split('/') : slug;
}